import React, { useEffect, useState } from "react";
import CreateSidebar from "../components/layouts/create/CreateSidebar";
import CreateProgreaabar from "../components/layouts/create/CreateProgreaabar";
import CreateStep1 from "../components/layouts/create/CreateStep1";
import CreateStep2 from "../components/layouts/create/CreateStep2";
import CreateStep3 from "../components/layouts/create/CreateStep3";
import Create3part2 from "../components/layouts/create/Create3part2";
import CreateStep4 from "../components/layouts/create/CreateStep4";
import CreateStep5 from "../components/layouts/create/CreateStep5";
import CreateStep6 from "../components/layouts/create/CreateStep6";
import CreateStep6part2 from "../components/layouts/create/CreateStep6part2";
import CreateStep7 from "../components/layouts/create/CreateStep7";
import CreateStep7Part2 from "../components/layouts/create/CreateStep7Part2";
import CreateStep8 from "../components/layouts/create/CreateStep8";
import CreateStepPart2 from "../components/layouts/create/CreateStep8Part2";
import CreateStep9 from "../components/layouts/create/CreateStep9";
import CreateStep10 from "../components/layouts/create/CreateStep10";
import Button from "../components/shared/Button";
import CreateStep11 from "../components/layouts/create/CreateStep11";
import { useParams } from "react-router-dom";
import useFetch from "../hooks/useAxios";
import { useCreatePlace } from "../context/CreatePlaceContext";
const Create = () => {
  const phase = [
    {
      phaseNum: 1,
      PhaseName: "نوع اقامتگاه",
      PhaseSub: [{ Subname: "نوع اقامتگاه", subphasenum: 1, currentpage: 1 }]
    },
    {
      phaseNum: 2,
      PhaseName: "درباره اقامتگاه",
      PhaseSub: [
        { Subname: "مشخصات کلی اقامتگاه", subphasenum: 1, currentpage: 2 }
      ]
    },
    {
      phaseNum: 3,
      PhaseName: "آدرس و موقعیت مکانی",
      PhaseSub: [
        { Subname: "آدرس اقامتگاه", subphasenum: 1, currentpage: 3 },
        { Subname: "موقعیت مکانی روی نقشه", subphasenum: 2, currentpage: 4 }
      ]
    },
    {
      phaseNum: 4,
      PhaseName: "ظرفیت اقامتگاه",
      PhaseSub: [{ Subname: "ظرفیت اقامتگاه", subphasenum: 1, currentpage: 5 }]
    },
    {
      phaseNum: 5,
      PhaseName: "اطلاعات محیطی",
      PhaseSub: [{ Subname: "اطلاعات محیطی", subphasenum: 1, currentpage: 6 }]
    },
    {
      phaseNum: 6,
      PhaseName: "امکانات و ویژگی ها",
      PhaseSub: [
        { Subname: "امکانات و ویژگی ها", subphasenum: 1, currentpage: 7 },
        { Subname: "ویژگی های اقامتگاه", subphasenum: 2, currentpage: 8 }
      ]
    },
    {
      phaseNum: 7,
      PhaseName: "قوانین",
      PhaseSub: [
        { Subname: "قوانین رزرو", subphasenum: 1, currentpage: 9 },
        //{ Subname: "قوانین لغو رزرو", subphasenum: 2, currentpage: 10 },
        { Subname: "قوانین جاتیک", subphasenum: 2 ,currentpage:11 }
      ]
    },
    {
      phaseNum: 8,
      PhaseName: "قیمت  گذاری",
      PhaseSub: [
        { Subname: "قیمت گذاری", subphasenum: 1, currentpage: 12 },
        { Subname: "تخفیف", subphasenum: 2, currentpage: 13 }
      ]
    },
    {
      phaseNum: 9,
      PhaseName: "بارگذاری تصاویر ",
      PhaseSub: [
        { Subname: "بارگذاری تصاویر ", subphasenum: 1, currentpage: 14 }
      ]
    },

    {
      phaseNum: 10,
      PhaseName: "اطلاعات مالکیت",
      PhaseSub: [{ Subname: "اطلاعات مالکیت", subphasenum: 1, currentpage: 16 }]
    }
  ];
  const [inforesidencedetail, setinforesidencedetail] = useState() //city //start //end //count
  const {setCreateInfoData,createInfoData,setResidenceId} = useCreatePlace()
  const {id}=useParams()
  const apiGetresidencedetailInfo = useFetch({
    method: "get",
    url: `api/host/residences/edit/${id}`,
    noHeader: false,
    trigger:id?  true :false,
    argFunc:(res)=>{
      console.log(res.data)
      console.log("facilities",res.data.residence.facilities.filter(i=>i.type === "safety").map(j=>({label:j.title,
        value:j.name})))
        setResidenceId(res.data.residence.id)
      setCreateInfoData(
        {
          stepOne: {
         category: res.data.residence.category //['apartment', 'villa', 'ecotourism_collection', 'hotel'
          },
          stepTwo: {
            title: res.data.residence.title,
            type: res.data.residence.type.name,
            space: res.data.residence.space === "دربست" ? "closed" : res.data.residence.space === "اتاق خصوصی" ? "private_room" : res.data.residence.space === "نیمه دربست" ? "sime_closed" : "shared_room" ,
            foundation_size: res.data.residence.foundation_size,
            area_size: res.data.residence.area_size,
            floors: res.data.residence.floors,
            description: res.data.residence.description
          },
          stepThree: {
            city: [{name:res.data.residence.city.name,title:res.data.residence.city.title}],
            village: res.data.residence.village,
            address: res.data.residence.address,
            postal_code:""
          },
          stepFour: {
            lat: res.data.residence.lat,
            lng: res.data.residence.lng
          },
          stepFive: {
          capacity: res.data.residence.capacity,
          max_capacity: res.data.residence.max_capacity,
          rooms_count: res.data.residence.rooms_count,
          double_bed_count: res.data.residence.sleep_space.double_bed_count,
          single_bed_count: res.data.residence.sleep_space.single_bed_count,
          traditional_bed_count: res.data.residence.sleep_space.traditional_bed_count,
          sleep_space_description: res.data.residence.sleep_space.description,
          custom_sleep_items:[]
          },
          stepSix: {
            environment_texture: res.data.env_texture.map(i=>({label:i.label,value:i.name})),
            access_path: res.data.residence.access_path,
      
            places:  {
               welfare: res.data.residence.places.filter(i=>i.type === "welfare"),
               sport:res.data.residence.places.filter(i=>i.type === "sport")
            }
          },
          stepSeven: {
            parkingCount: 0,
            bathroom: 0,
            restroom: 0,
            custom_facilities:res.data.residence.custom_facilities !== null ? {
              welfare: res.data.residence.custom_facilities?.filter(i=>i.type === "welfare").map(j=>({label:j.title,
                value:j.name}))  ,
                      sport: res.data.residence.custom_facilities?.filter(i=>i.type === "sport").map(j=>({label:j.title,
                value:j.name})),
                      heating: res.data.residence.custom_facilities?.filter(i=>i.type === "heating").map(j=>({label:j.title,
                value:j.name})),
                      cooling: res.data.residence.custom_facilities?.filter(i=>i.type === "cooling").map(j=>({label:j.title,
                value:j.name})),
                      kitchen: res.data.residence.custom_facilities?.filter(i=>i.type === "kitchen").map(j=>({label:j.title,
                value:j.name})),
                      safety: res.data.residence.custom_facilities?.filter(i=>i.type === "safety").map(j=>({label:j.title,
                value:j.name}))
             }: {
                      welfare: [] ,
                      sport:[],
                      heating: [],
                      cooling:[],
                      kitchen: [],
                      safety: []
            },
            facilities: {
              welfare: res.data.residence.facilities.filter(i=>i.type === "welfare").map(j=>({label:j.title,
                 value:j.name})),
              sport: res.data.residence.facilities.filter(i=>i.type === "sport").map(j=>({label:j.title,
                 value:j.name})),
              heating: res.data.residence.facilities.filter(i=>i.type === "heating").map(j=>({label:j.title,
                 value:j.name})),
              cooling: res.data.residence.facilities.filter(i=>i.type === "cooling").map(j=>({label:j.title,
                 value:j.name})),
              kitchen: res.data.residence.facilities.filter(i=>i.type === "kitchen").map(j=>({label:j.title,
                 value:j.name})),
                                safety: res.data.residence.facilities.filter(i=>i.type === "safety").map(j=>({label:j.title,
        value:j.name}))
            }
          },
          stepEight: {
               elderly_and_minors: res.data.residence.service.elderly_and_minors === 1 ?true:false,
               physical_disabilities: res.data.residence.service.physical_disabilities === 1 ?true:false,
               disinfected: res.data.residence.service.disinfected === 1 ?true:false,
               long_term: res.data.residence.service.long_term === 1 ?true:false,
               have_janitor: res.data.residence.service.have_janitor === 1 ?true:false,
               economical: res.data.residence.service.economical === 1 ?true:false,
               luxury: res.data.residence.service.luxury === 1 ?true:false
          },
          stepNine: {
               entrance_time: res.data.residence.regulation.entrance_time,
               leaving_time: res.data.residence.regulation.leaving_time,
               min_stay: res.data.residence.regulation.min_stay,
               max_stay: res.data.residence.regulation.max_stay,
               pet_check_in: res.data.residence.regulation.pet_check_in === 1 ? true : false,
               smoking: res.data.residence.regulation.smoking === 1 ? true : false,
               single: res.data.residence.regulation.single === 1 ? true : false,
               party: res.data.residence.regulation.party === 1 ? true:false
          },
          stepTen: {
               cancel_regulation: res.data.residence.regulation.cancel_regulation //"strict","permissive"
          },
          stepTwelve: {
            peak_day: res.data.residence.general_price.peak_days,
            weekend: res.data.residence.general_price.weekend,
            in_week: res.data.residence.general_price.in_week,
            per_extra_person: res.data.residence.per_extra_person
          },
          stepthirteen: {
                general_discount:res.data.residence.general_discount? res.data.residence.general_discount.map(i=>({
                discount_type:i.type,
                percentage_amount: i.percentage_amount,
                day_count: i.count_days
            }))
            :
            [
              {
                discount_type: "short",
                percentage_amount: "",
                day_count: ""
              },
              {
                discount_type: "long",
                percentage_amount: "",
                day_count: ""
              }
            ]
          },
          stepFourteen: {
            thumbnail:res.data.residence.thumbnail.path ,
            media:[],
            newMedia:res.data.residence.medias
          },
      
          stepSixteen: {
            document_image: res.data.residence.document_image.path,
            owner_certificate: res.data.residence.owner_certificate?.path,
            emergency_user_name: res.data.residence.emergency_name,
            emergency_number: res.data.residence.emergency_phone,
            ownership_type:res.data.residence.ownership_type
          }
        }
      )
    }
  });
  
  const [currentPhase, setCurrentPhase] = useState(1);
  const [currentsubPhase, setCurrentsubPhase] = useState(1);

  const nextStep = () => {
    if (phase[currentPhase - 1].PhaseSub.length === 1) {
      setCurrentPhase(prev => prev + 1);
      setCurrentsubPhase(1);
    } else if (currentsubPhase < phase[currentPhase - 1].PhaseSub.length) {
      setCurrentsubPhase(prev => prev + 1);
    } else if (currentsubPhase === phase[currentPhase - 1].PhaseSub.length) {
      setCurrentPhase(prev => prev + 1);
      setCurrentsubPhase(1);
    }
  };
  const { step, substep } = useParams();
  const prevStep = () => {
    if (
      phase[currentPhase - 1].PhaseSub[currentsubPhase - 1].subphasenum === 1
    ) {
      setCurrentPhase(prev => prev - 1);
      setCurrentsubPhase(phase[currentPhase - 2].PhaseSub.length);
    } else if (currentsubPhase <= phase[currentPhase - 1].PhaseSub.length) {
      setCurrentsubPhase(prev => prev - 1);
    }
  };
 

  useEffect(() => {
    if (step) {
      setCurrentPhase(parseInt(step));
      setCurrentsubPhase(parseInt(substep));
    }
  }, []);
  useEffect(
    () => {
      window.scrollTo(0, 0);
    },
    [currentsubPhase, currentPhase]
  );
  

  const pagerender = () => {
    if (currentPhase === 1 && currentsubPhase === 1) {
      return  <CreateStep1 prevStep={prevStep} nextStep={nextStep} />;
    } else if (currentPhase === 2 && currentsubPhase === 1) {
      return <CreateStep2 prevStep={prevStep} nextStep={nextStep} />;
    } else if (currentPhase === 3 && currentsubPhase === 1) {
      return <CreateStep3 prevStep={prevStep} nextStep={nextStep} />;
    } else if (currentPhase === 3 && currentsubPhase === 2) {
      return <Create3part2 prevStep={prevStep} nextStep={nextStep} />;
    } else if (currentPhase === 4 && currentsubPhase === 1) {
      return <CreateStep4 prevStep={prevStep} nextStep={nextStep} />;
    } else if (currentPhase === 5 && currentsubPhase === 1) {
      return <CreateStep5 prevStep={prevStep} nextStep={nextStep} />;
    } else if (currentPhase === 6 && currentsubPhase === 1) {
      return <CreateStep6 prevStep={prevStep} nextStep={nextStep} />;
    } else if (currentPhase === 6 && currentsubPhase === 2) {
      return <CreateStep6part2 prevStep={prevStep} nextStep={nextStep} />;
    } else if (currentPhase === 7 && currentsubPhase === 1) {
      return <CreateStep7 prevStep={prevStep} nextStep={nextStep} />;
    } else if (currentPhase === 7 && currentsubPhase === 2) {
      return <CreateStep7Part2 prevStep={prevStep} nextStep={nextStep} />;
    } else if (currentPhase === 8 && currentsubPhase === 1) {
      return <CreateStep8 prevStep={prevStep} nextStep={nextStep} />;
    } else if (currentPhase === 8 && currentsubPhase === 2) {
      return <CreateStepPart2 prevStep={prevStep} nextStep={nextStep} />;
    } else if (currentPhase === 9 && currentsubPhase === 1) {
      return <CreateStep9 prevStep={prevStep} nextStep={nextStep} />;
    } else if (currentPhase === 10 && currentsubPhase === 1) {
      return <CreateStep11 prevStep={prevStep} />;
    }
  };
  return (
    <div className="container">
      <div className="creat">
        <div className="sidebar">
          <CreateSidebar
            phase={phase}
            currentPhase={currentPhase}
            currentsubPhase={currentsubPhase}
          />
        </div>
        <div>
          <CreateProgreaabar
            title={
              phase
                .filter(i => i.phaseNum === currentPhase)[0]
                .PhaseSub.filter(i => i.subphasenum === currentsubPhase)[0]
                .Subname
            }
            page={16}
            currentpage={
              phase
                .filter(i => i.phaseNum === currentPhase)[0]
                .PhaseSub.filter(i => i.subphasenum === currentsubPhase)[0]
                .currentpage
            }
          />
          <div className="create-box">
            {pagerender()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;


